import * as z from "zod";

/**
 * Product kinds Adyen prohibits for platform sub-merchants (its Prohibited and
 * Restricted List, platform column); a flag pauses onboarding for review.
 */
export const RestrictedCategory = {
  REGULATED_NUTRACEUTICALS: "regulated_nutraceuticals",
  TOBACCO_NICOTINE_VAPE: "tobacco_nicotine_vape",
  DRUGS_PSYCHOACTIVE: "drugs_psychoactive",
  RESEARCH_CHEMICALS: "research_chemicals",
  IV_THERAPY: "iv_therapy",
  ADULT_FETISH: "adult_fetish",
  WEAPONS_EXPLOSIVES: "weapons_explosives",
  HUMAN_BODY_FLUIDS: "human_body_fluids",
  COUNTERFEIT: "counterfeit",
} as const;
export type RestrictedCategory =
  (typeof RestrictedCategory)[keyof typeof RestrictedCategory];

export const RESTRICTED_CATEGORIES: readonly RestrictedCategory[] =
  Object.values(RestrictedCategory);

export const RESTRICTED_CATEGORY_DESCRIPTIONS: Readonly<
  Record<RestrictedCategory, string>
> = {
  regulated_nutraceuticals:
    "CBD, THC, delta-8/9/10, HHC or other cannabinoid products, cannabis, and kava. Hemp seed oil or hemp hearts without cannabinoids are not.",
  tobacco_nicotine_vape:
    "Cigarettes, cigars, tobacco, nicotine pouches, e-cigarettes, vapes, e-liquids and vaping accessories. Nicotine-replacement therapy (gum, patches, lozenges) is not.",
  drugs_psychoactive:
    "Drug paraphernalia, kits or equipment for growing or producing drugs, and psychoactive products or substances that mimic illegal drugs (kratom, psychedelic or amanita mushrooms, nitrous oxide chargers, poppers).",
  research_chemicals:
    "Research chemicals, SARMs, research peptides (BPC-157, TB-500) and hazardous chemicals sold to consumers, often labeled 'for research use only' or 'not for human consumption'. Collagen peptides are not.",
  iv_therapy:
    "Intravenous therapy: IV drips, vitamin or hangover infusions, and IV therapy kits or services.",
  adult_fetish:
    "Fetish products and sexual content (books, videos, streaming). General sexual wellness products are not.",
  weapons_explosives:
    "Firearms, firearm parts, ammunition, military arms, explosives, fireworks, and flammable or radioactive materials.",
  human_body_fluids:
    "Human body parts or bodily fluids for sale, such as donor breast milk. Hair, teeth, and breast milk storage or pumping supplies are not.",
  counterfeit:
    "Counterfeit or replica branded goods, or products designed to circumvent intellectual-property or copy protection.",
};

export const restrictedCategorySchema: z.ZodType<RestrictedCategory> =
  z.enum(RestrictedCategory);

const restrictedCategoryMatchSchema_ = z.object({
  category: restrictedCategorySchema,
  /** Catalog strings that drove the flag (titles, tags, vendors, category paths). */
  matches: z.array(z.string()),
  /** Null when the term list alone decided; the model probability otherwise. */
  confidence: z.number().nullable(),
});
export const restrictedCategoryMatchSchema: z.ZodType<RestrictedCategoryMatch> =
  restrictedCategoryMatchSchema_;
export interface RestrictedCategoryMatch extends z.infer<
  typeof restrictedCategoryMatchSchema_
> {}
